import { designFr } from './design.fr.js';
import { familyFr } from './family.fr.js';
import { foodFr } from './food.fr.js';
import { kamersFr } from './kamers.fr.js';
import { kioskBoardFr } from './kioskBoard.fr.js';
import { kioskPrivacyFr } from './kioskPrivacy.fr.js';
import { kioskMoveFr } from './kioskMove.fr.js';
import { readAloudFr } from './readAloud.fr.js';
import { todoFr } from './todo.fr.js';
import { kioskWeatherFr } from './kioskWeather.fr.js';
import { kioskTimerFr } from './kioskTimer.fr.js';
import { hallwayFr } from './hallway.fr.js';
import { kioskRemindersFr } from './reminders.fr.js';
// Frans (fr-FR): teksten van het bord (zelfde vorm als nl.ts). Tu-vorm, zoals het Nederlandse je;
// vaste spatie voor : (U+00A0) en smalle vaste spatie voor ; ? ! en binnen « » (U+202F). Wat
// ontbreekt valt terug op het Nederlands.
// Sleutels die in nl.ts zelf staan (common, kiosk, web, …) horen hier; de rest in het eigen
// domeinbestand (design.fr.ts, food.fr.ts, …).
export const fr = {
    weekdays: ['lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'],
    weekdaysShort: ['lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.', 'dim.'],
    months: [
        'janvier',
        'février',
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        'août',
        'septembre',
        'octobre',
        'novembre',
        'décembre',
    ],
    monthsShort: [
        'janv.',
        'févr.',
        'mars',
        'avr.',
        'mai',
        'juin',
        'juil.',
        'août',
        'sept.',
        'oct.',
        'nov.',
        'déc.',
    ],
    design: designFr,
    food: foodFr,
    family: familyFr,
    kamers: kamersFr,
    reminders: kioskRemindersFr,
    weather: kioskWeatherFr,
    // Timer op het bord (oprichter 1 okt 2026).
    timer: kioskTimerFr,
    // Golf 6b (0043): het bord in de gang van een gedeelde woning (hallway.fr.ts).
    hallway: hallwayFr,
    // 0036: melding "Dit bord stopt op ..." (golf 4).
    privacy: kioskPrivacyFr,
    move: kioskMoveFr,
    readAloud: readAloudFr,
    // 0058: to-do's onder de taken van een lid (todo.fr.ts).
    todo: todoFr,
    common: {
        adjustBoard: 'Adapter',
        refreshBoard: 'Actualiser',
        create: 'Créer',
        agendaBoard: 'Agenda',
        today: 'Aujourd’hui',
        tomorrow: 'Demain',
        now: 'Maintenant',
        later: 'Plus tard',
        done: 'Fini',
        cancel: 'Annuler',
        confirm: 'Confirmer',
        back: 'Retour',
        close: 'Fermer',
    },
    kiosk: {
        ...kioskBoardFr,
        // 0035: gepauzeerd door AMUMIN Beheer (golf 4).
        paused: 'Lecture seule',
        pausedHint: 'Le tableau est en lecture seule pour le moment. Tu pourras cocher plus tard.',
        agenda: 'Agenda',
        tasks: 'Tâches',
        rewards: 'Récompenses',
        nothingToday: 'Rien de prévu aujourd’hui',
        nothingMore: 'Plus rien aujourd’hui',
        noTasks: 'Pas de tâches aujourd’hui',
        allDone: 'Tout est fini !',
        /** Rustig, buiten het thema Kinderen. */
        allDoneCalm: 'Tout est fait',
        allDay: 'Toute la journée',
        everyone: 'Tout le monde',
        next: 'Ensuite',
        startsIn: 'dans {time}',
        busyFor: 'encore {time}',
        minutesShort: '{count} min',
        hoursShort: '{h} h {m} min',
        tasksProgress: '{done} sur {total} finies',
        pairTitle: 'Associer cette tablette',
        pairHint: 'Saisis ce code sur ton téléphone :',
        pairScan: 'Ou scanne le code QR avec ton téléphone',
        pairWaiting: 'En attente de validation…',
        pairStarting: 'Recherche d’un code…',
        pairExpired: 'Code expiré, nouveau code en cours…',
        pairNoConnection: 'Pas de connexion au serveur, nouvel essai…',
        pairQrClaiming: 'Liaison avec le code QR…',
        pairQrInvalid: 'Ce code QR a expiré ou a déjà servi. Créez-en un nouveau dans l’app parents, ou reliez avec le code affiché sur cet écran.',
        pairQrLimit: 'Votre abonnement ne permet pas d’autre tablette. Déliez d’abord une autre tablette dans l’app parents.',
        pairQrBusy: 'Un peu trop de tentatives. Attendez une minute, puis scannez à nouveau le code QR.',
        pairQrOffline: 'Pas de connexion, le code QR n’a donc pas fonctionné. Scannez-le à nouveau, ou reliez avec le code affiché sur cet écran.',
        offline: 'Pas de connexion, dernière mise à jour à {time}',
        offlineBadge: 'Pas de connexion',
        renderFailed: 'Le tableau ne peut pas afficher l’agenda pour l’instant et va réessayer.',
        checkInApp: 'Vérifie cette tablette dans l’appli parents',
        staleData: 'Pas de données à jour',
        standaloneTitle: 'Ajoute le tableau familial à l’écran d’accueil',
        standaloneBody: 'Dans Safari, touche Partager puis « Sur l’écran d’accueil ». Ouvre ensuite le tableau avec cette icône, sinon l’association n’est pas gardée.',
        points: { one: '{count} point', other: '{count} points' },
        tasksLeft: { one: 'Encore {count} tâche', other: 'Encore {count} tâches' },
    },
    web: {
        // 0035: gepauzeerd door AMUMIN Beheer (423 household_paused).
        householdPaused: 'Votre tableau familial est en lecture seule pour le moment. Les modifications ne sont pas possibles.',
        appName: 'AMUMIN Family Board',
        loginTitle: 'Connexion',
        email: 'Adresse e-mail',
        password: 'Mot de passe',
        login: 'Se connecter',
        forgotPassword: 'Mot de passe oublié ?',
        noAccount: 'Pas encore de compte ?',
        register: 'Créer un compte',
        save: 'Enregistrer',
        add: 'Ajouter',
        edit: 'Modifier',
        remove: 'Supprimer',
        loading: 'Chargement…',
        retry: 'Réessayer',
        close: 'Fermer',
        reload: 'Recharger',
        none: 'Aucun',
        errorGeneric: 'Un problème est survenu. Réessaie.',
        errorNetwork: 'Pas de connexion au serveur.',
        errorNotFound: 'Cette page n’existe pas.',
        moduleOff: 'Cette fonction est désactivée pour ta famille.',
        /** 0023/0043: dit lid geeft zelf toestemming (consent_self_required). */
        consentSelfRequired: 'Une personne de 16 ans ou plus donne elle-même son accord. Vérifiez les âges dans Membres, puis réessayez.',
        versionConflict: 'Quelqu’un d’autre a modifié ceci entre-temps. La liste a été rechargée ; réessaie.',
        rateLimited: 'Trop de tentatives. Réessaie dans {seconds} secondes.',
        sessionExpired: 'Ta session a expiré. Reconnecte-toi.',
        nav: {
            today: 'Aujourd’hui',
            agenda: 'Agenda',
            members: 'Membres',
            devices: 'Appareils',
            security: 'Sécurité',
            household: 'Foyer',
            logout: 'Se déconnecter',
        },
        timeInAmsterdam: 'Heure d’Amsterdam',
        browserZoneDiffers: 'Ton navigateur est dans un autre fuseau horaire ; toutes les heures ici sont à l’heure d’Amsterdam.',
        householdSwitch: 'Foyer actif',
        sharedComputer: 'Ordinateur partagé ou public',
        sharedComputerHint: 'Ta session expire après 24 heures et ce navigateur n’est pas mémorisé.',
        stayLoggedIn: 'Rester connecté',
        invalidCredentials: 'Adresse e-mail ou mot de passe incorrect.',
        emailNotVerified: 'Confirme d’abord ton adresse e-mail avec le lien reçu par e-mail.',
        outsideTrustedNetwork: 'Tu es hors d’un réseau de confiance. Reconnecte-toi avec ton mot de passe et un code e-mail.',
        forgetToLogout: 'N’oublie pas de te déconnecter quand tu as fini.',
        lockedOut: 'Trop d’échecs. Réessaie plus tard.',
        codeTitle: 'Code e-mail',
        codeIntro: 'Nous avons envoyé un code à 6 chiffres à {email}. Il est valable 10 minutes.',
        codeLabel: 'Code reçu par e-mail',
        codeInvalid: 'Saisis les 6 chiffres de l’e-mail.',
        codeWrong: 'Ce code est incorrect. Encore {count} essais.',
        codeWrongPlain: 'Ce code est incorrect.',
        codeLocked: 'Trop de codes erronés. Reconnecte-toi pour recevoir un nouveau code.',
        codeExpired: 'Le code a expiré. Reconnecte-toi pour recevoir un nouveau code.',
        trustBrowser: 'Faire confiance à ce navigateur pendant 30 jours',
        trustBrowserHint: 'Jusqu’au {date}, plus de code e-mail dans ce navigateur.',
        resend: 'Renvoyer le code',
        resendIn: 'Renvoi possible dans {seconds} s',
        resent: 'Nouveau code envoyé ; l’ancien code n’est plus valable.',
        notMeLink: 'Ce n’était pas moi',
        noPendingCode: 'Aucune connexion en attente. Connecte-toi d’abord.',
        networkConfirmIntro: 'Confirme le nouveau réseau de confiance avec le code à 6 chiffres envoyé à {email}.',
        registerTitle: 'Créer un compte',
        passwordHint: 'Au moins 12 caractères.',
        passwordTooShort: 'Utilise au moins 12 caractères.',
        passwordTooLong: 'Utilise au maximum 256 caractères.',
        emailInvalid: 'Vérifie ton adresse e-mail.',
        passwordRepeat: 'Répète le mot de passe',
        passwordMismatch: 'Les mots de passe ne sont pas identiques.',
        registerDone: 'Vérifie tes e-mails',
        registerDoneText: 'Nous avons envoyé un lien de confirmation à {email}. Clique dessus pour activer ton compte.',
        alreadyAccount: 'Déjà un compte ?',
        emailTaken: 'Un compte existe déjà avec cette adresse e-mail.',
        passwordBreached: 'Ce mot de passe figure dans une fuite de données. Choisis-en un autre.',
        privateEmailHint: 'Astuce : utilise une adresse e-mail privée, pas celle du travail.',
        verifyTitle: 'Confirmer l’adresse e-mail',
        verifyIntro: 'Clique sur le bouton pour confirmer ton adresse e-mail.',
        verifyButton: 'Confirmer',
        verifying: 'Confirmation en cours…',
        verifyDone: 'Ton adresse e-mail est confirmée. Tu peux maintenant te connecter.',
        verifyInvalid: 'Ce lien n’est pas valable ou a expiré.',
        tokenMissing: 'Ce lien est incomplet. Rouvre le lien de l’e-mail.',
        toLogin: 'Aller à la connexion',
        resetTitle: 'Mot de passe oublié',
        resetIntro: 'Saisis ton adresse e-mail. Si un compte existe, nous envoyons un lien pour changer ton mot de passe (valable 60 minutes).',
        resetSend: 'Envoyer le lien',
        resetSent: 'Si un compte existe avec {email}, un e-mail est en route.',
        resetConfirmTitle: 'Nouveau mot de passe',
        newPassword: 'Nouveau mot de passe',
        resetConfirmButton: 'Changer le mot de passe',
        resetDone: 'Ton mot de passe a été changé. Tous les navigateurs de confiance sont oubliés ; à la prochaine connexion, nous redemandons un code e-mail.',
        resetInvalid: 'Ce lien de réinitialisation n’est pas valable ou a expiré.',
        notMeTitle: 'Ce n’était pas moi',
        notMeIntro: 'Quelqu’un a essayé de se connecter avec ton mot de passe. Ce n’était pas toi ? Alors nous verrouillons ton compte.',
        notMeWhatHappens: 'Ce qui se passe quand tu appuies sur le bouton :',
        notMeStep1: 'La tentative de connexion en attente est bloquée.',
        notMeStep2: {
            one: '{count} navigateur de confiance est oublié.',
            other: '{count} navigateurs de confiance sont oubliés.',
        },
        notMeStep2Unknown: 'Tous les navigateurs de confiance sont oubliés.',
        notMeStep3: {
            one: '{count} code de connexion en attente n’est plus valable.',
            other: '{count} codes de connexion en attente ne sont plus valables.',
        },
        notMeStep4: 'Tu reçois un e-mail pour choisir un nouveau mot de passe.',
        notMeButton: 'Oui, ce n’était pas moi',
        notMeDone: 'C’est fait. Regarde tes e-mails pour le lien vers un nouveau mot de passe.',
        notMeInvalid: 'Ce lien n’est pas valable ou a déjà servi.',
        stepUpTitle: 'Confirme avec ton mot de passe',
        stepUpIntro: 'Pour cette action, nous redemandons ton mot de passe, même à la maison. C’est valable 10 minutes.',
        stepUpButton: 'Confirmer',
        stepUpWrong: 'Mot de passe incorrect.',
        stepUpCancelled: 'Action annulée.',
        wizardTitle: 'Configurer ton foyer',
        wizardIntro: 'Quelques réglages pour commencer ; tout se modifie plus tard.',
        wizardHouseholdName: 'Nom du foyer',
        wizardHouseholdHint: 'Affiché en haut du tableau, par exemple « Famille Martin ».',
        wizardYou: 'Ton nom sur le tableau',
        wizardPinTitle: 'Code PIN parent',
        wizardPinPlaceholder: 'Bientôt : ici, tu choisiras le PIN du mode parent de la tablette, avec confirmation par mot de passe.',
        wizardInviteTitle: 'Inviter le second parent',
        wizardInvitePlaceholder: 'Bientôt : invitation par e-mail ; l’autre parent aura les mêmes droits dans ce foyer.',
        wizardTrustTitle: 'Faire confiance à ce réseau',
        wizardTrustHint: 'Se règle dans Sécurité : à la maison, plus de code e-mail.',
        wizardSaved: 'Foyer enregistré.',
        householdNameRequired: 'Saisis un nom.',
        todayTitle: 'Aujourd’hui',
        todayEmpty: 'Rien de prévu aujourd’hui.',
        tasksTitle: 'Tâches',
        tasksEmpty: 'Pas de tâches aujourd’hui.',
        allDay: 'Toute la journée',
        everyone: 'Tout le monde',
        doneBy: 'Fini',
        quickAdd: 'Ajout rapide',
        agendaTitle: 'Agenda',
        newEvent: 'Événement rapide',
        newTask: 'Tâche rapide',
        title: 'Titre',
        date: 'Date',
        start: 'Début',
        duration: 'Durée (minutes)',
        forWhom: 'Pour qui',
        allDayLabel: 'Toute la journée',
        icon: 'Icône',
        iconNone: 'Pas d’icône',
        location: 'Lieu',
        createEvent: 'Ajouter l’événement',
        createTask: 'Ajouter la tâche',
        eventCreated: 'Événement ajouté.',
        taskCreated: 'Tâche ajoutée.',
        titleRequired: 'Saisis un titre.',
        titleTooLong: '120 caractères au maximum.',
        dateInvalid: 'Choisis une date valable (AAAA-MM-JJ).',
        memberRequired: 'Choisis au moins un membre.',
        startInvalid: 'Choisis une heure de début (HH:MM).',
        durationInvalid: 'La durée va de 5 à 1440 minutes.',
        listFor: 'Agenda du {date}',
        showDay: 'Afficher',
        deleteEvent: 'Supprimer l’événement',
        deleteTask: 'Supprimer la tâche',
        itemDeleted: 'Supprimé.',
        noEventsDay: 'Aucun événement ce jour-là.',
        noTasksDay: 'Aucune tâche ce jour-là.',
        membersTitle: 'Membres',
        membersIntro: 'Tous ceux qui figurent sur le tableau, avec ou sans compte.',
        addMember: 'Ajouter un membre',
        editMember: 'Modifier le membre',
        memberName: 'Nom',
        memberKind: 'Type',
        kindAdult: 'Adulte',
        kindChild: 'Enfant',
        kindHelper: 'Aide',
        color: 'Couleur',
        avatarIcon: 'Icône d’avatar',
        ageBand: 'Tranche d’âge',
        ageBandNone: 'Non renseignée',
        nameRequired: 'Saisis un nom.',
        nameTooLong: '40 caractères au maximum.',
        memberSaved: 'Membre enregistré.',
        colorNames: {
            orange: 'Orange',
            skyblue: 'Bleu ciel',
            bluishgreen: 'Bleu-vert',
            yellow: 'Jaune',
            blue: 'Bleu',
            vermillion: 'Vermillon',
            reddishpurple: 'Pourpre',
            black: 'Noir',
        },
        devicesTitle: 'Appareils',
        devicesEmpty: 'Aucune tablette associée pour l’instant.',
        pairDevice: 'Associer',
        deviceName: 'Nom',
        room: 'Pièce',
        status: 'Statut',
        lastSeen: 'Vu pour la dernière fois',
        lastSync: 'Dernière synchro',
        statusActive: 'Active',
        statusRevoked: 'Révoquée',
        statusSuspect: 'Suspecte',
        online: 'En ligne',
        offline: 'Hors ligne',
        never: 'Jamais',
        justNow: 'à l’instant',
        minutesAgo: { one: 'il y a {count} minute', other: 'il y a {count} minutes' },
        hoursAgo: { one: 'il y a {count} heure', other: 'il y a {count} heures' },
        daysAgo: { one: 'il y a {count} jour', other: 'il y a {count} jours' },
        rename: 'Renommer',
        revoke: 'Révoquer',
        revokeConfirm: 'Veux-tu vraiment révoquer « {name} » ? La tablette affichera l’écran d’association d’ici une minute.',
        revokeYes: 'Oui, révoquer',
        deviceRevoked: 'Appareil révoqué.',
        deviceSaved: 'Appareil enregistré.',
        appVersion: 'Version',
        standalone: 'Appli écran d’accueil',
        swState: 'Service worker',
        storageOk: 'Stockage',
        clockOffset: 'Décalage d’horloge',
        pairTitle: 'Associer une tablette',
        pairIntro: 'Saisis le code affiché sur la tablette.',
        pairCode: 'Code',
        pairReviewIntro: 'Vérifiez le code sur votre tablette, puis choisissez son nom et sa pièce.',
        pairConnect: 'Connecter cette tablette',
        pairMatch: 'Ce code correspond-il à celui de votre tablette ?',
        pairChangeCode: 'Saisir un autre code',
        pairDetails: 'Détails de l’appareil',
        pairNameLabel: 'Nom de la tablette',
        pairNameHint: 'Vous pourrez modifier ce nom plus tard.',
        pairNext: 'Retournez sur votre tablette. Le tableau s’y ouvrira automatiquement.',
        pairCodeInvalid: 'Le code a 8 caractères, par exemple 1234-5678.',
        pairLookup: 'Vérifier le code',
        pairNotFound: 'Code inconnu ou expiré. Vérifie le code sur la tablette.',
        pairTooMany: 'Trop de codes erronés pendant cette session. Reconnecte-toi.',
        pairUserAgent: 'Navigateur',
        pairPlatform: 'Plateforme',
        pairCountry: 'Pays',
        pairStarted: 'Démarré',
        pairUnknown: 'inconnu',
        pairApprove: 'Valider',
        pairApproved: 'Tablette « {name} » associée. Le tableau apparaît dans quelques secondes.',
        roomRequired: 'Choisis une pièce.',
        toDevices: 'Aller aux appareils',
        securityTitle: 'Sécurité',
        trustedNetworksTitle: 'Réseaux de confiance',
        trustedNetworksIntro: 'Sur un réseau de confiance, pas de code e-mail ; ton mot de passe reste toujours nécessaire.',
        trustThisNetwork: 'Faire confiance à ce réseau',
        trustServerWan: 'Faire confiance à l’adresse Internet du serveur',
        currentPrefix: 'Tu es actuellement sur {prefix}',
        serverWanLabel: 'Adresse Internet du serveur : {ip}',
        currentPrefixUnknown: 'Ton adresse Internet est inconnue.',
        networkNoSuggestion: 'Ce réseau ne peut pas être ajouté comme réseau de confiance (par exemple un réseau local ou un réseau partagé du fournisseur).',
        networkAlreadyTrusted: 'Ce réseau est déjà de confiance.',
        addNetwork: 'Ajouter un réseau',
        label: 'Libellé',
        labelRequired: 'Saisis un libellé.',
        kind: 'Type',
        kindCidr: 'Réseau (CIDR, p. ex. 192.168.1.0/24)',
        kindIp: 'Une adresse (IPv4)',
        kindServerWan: 'Adresse Internet du serveur (suit automatiquement)',
        kindDdns: 'Nom d’hôte DDNS',
        value: 'Valeur',
        valueInvalid: 'Valeur non valable pour ce type de réseau.',
        valueIpv6: 'IPv6 n’est pas encore pris en charge.',
        valueCgnat: 'Cette adresse appartient à un réseau partagé du fournisseur (CGNAT) et ne peut pas être de confiance.',
        scope: 'S’applique à',
        scopeHousehold: 'Tout le foyer',
        scopeIdentity: 'Moi seulement',
        rememberDefault: '« Rester connecté » est activé par défaut sur ce réseau',
        officeWarning: 'Toute personne derrière cette adresse évite le contrôle par e-mail. Est-ce une adresse professionnelle fixe ?',
        mobileHint: 'Sur mobile ou en 4G ? Utilise plutôt « Faire confiance à ce navigateur pendant 30 jours » à la connexion.',
        networkCreated: 'Réseau ajouté. Confirme-le avec le code e-mail.',
        networkConfirmed: 'Réseau confirmé. Sur ce réseau, plus de code e-mail.',
        unconfirmed: 'Pas encore confirmé',
        confirmedAt: 'Confirmé',
        lastMatched: 'Dernière correspondance',
        disabledLabel: 'Désactivé',
        enabledLabel: 'Activé',
        disable: 'Désactiver',
        enable: 'Activer',
        thisNetwork: 'ce réseau',
        noNetworks: 'Aucun réseau de confiance pour l’instant.',
        trustedBrowsersTitle: 'Navigateurs de confiance',
        trustedBrowsersIntro: 'Après mot de passe + code e-mail, nous faisons confiance à un navigateur pendant 30 jours ; ensuite, nous redemandons un code.',
        thisBrowser: 'Ce navigateur',
        issued: 'Émis',
        trustedUntil: 'De confiance jusqu’au {date}',
        lastUsedAt: 'utilisé pour la dernière fois {when}',
        expiresOn: 'expire le {date}',
        todayAt: 'aujourd’hui à {time}',
        yesterdayAt: 'hier à {time}',
        expires: 'Expire',
        lastUsed: 'Dernière utilisation',
        forget: 'Oublier',
        forgetOthers: 'Oublier tous les autres navigateurs',
        noTrustedBrowsers: 'Aucun navigateur de confiance.',
        browserForgotten: 'Navigateur oublié.',
        sessionsTitle: 'Sessions',
        routeLabel: 'Accès',
        routeBrowser: 'navigateur de confiance',
        routeNetwork: 'réseau de confiance',
        routeOnce: 'unique (24 heures)',
        routeNone: 'aucun',
        thisSession: 'Cette session',
        revokeSession: 'Révoquer',
        logoutEverywhere: 'Se déconnecter partout',
        logoutForget: 'Se déconnecter et oublier ce navigateur',
        sessionRevoked: 'Session révoquée.',
    },
};
//# sourceMappingURL=fr.js.map